export default {
    //关闭登录窗口
    closeLoginDialog(state) {
        state.loginStep = '';
    },
    /*登录窗口方法end*/
    //设置用户信息
    setUser(state, userData) {
        state.user = userData;
        window.localStorage.user = JSON.stringify(state.user);
    },
    setNewCommer(state, val) {
        state.isNewCommer = val;
        window.localStorage.user = JSON.stringify(state.user);
    },

    setUserInfo(state, data) {
        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                state.user[key] = data[key];
            }
        }
        window.localStorage.user = JSON.stringify(state.user);
    },
    setLoginStepLogin(state) {
        state.loginStep = 'login';
    },
    setLoginStep(state, stepValue) {
        state.loginStep = stepValue;
    },
    // 设置在线反馈
    setFeedback(state, val) {
        state.feedbackVisible = val;
    },
    // 设置检测状态
    setCheckStatus(state, val) {
        state.checkStatus = val;
    },
    /**
     * 百度统计事件统计
     * API介绍
     * 用于触发某个事件，如某个按钮的点击，或播放器的播放/停止，以及游戏的开始/暂停等。
     * 事件跟踪的数据不会被记入到页面PV中，适合用来统计所有的不需要看做PV的页面事件点击。
     * 已有数据的事件可以在设置中添加为事件转化，跟更多维度数据结合（如来源、入口页面等），进行转化分析。
     * @param category - 要监控的目标的类型名称，通常是同一组目标的名字，比如”视频”、”音乐”、”软件”、”游戏”等等。该项必选。
     * @param action - 用户跟目标交互的行为，如”播放”、”暂停”、”下载”等等。该项必选。
     * @param opt_label - 事件的一些额外信息，通常可以是歌曲的名称、软件的名称、链接的名称等等。该项可选。
     * @param opt_value - 事件的一些数值信息，比如权重、时长、价格等等，在报表中可以看到其平均值等数据。该项可选。
     */
    bdTrackEvent(state, [category, action, opt_label, opt_value]) {
        window._hmt && window._hmt.push(['_trackEvent', category, action, opt_label, opt_value]);
    },
    /**
     * 百度统计事件统计
     * API介绍
     * 使用场景：用于发送某个指定URL的PV统计请求
     * @param pageURL - 页面url路径
     */
    bdTrankPageview(pageURL) {
        window._hmt && window._hmt.push(['_trackPageview', pageURL]);
    }
};



// WEBPACK FOOTER //
// ./app/store/mutations.js